const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowPrimaryHeader', ['PageMetadataService', require('./primary-header-directive.js')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/accessiblity/primaryHeader/index.js
 **/